import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel } from '../../../../../../../utils/rel';
import errorBoundary from '@ifeng/errorBoundary';
import { getDealer, getCityInfo } from '../../../../../../../services/api';

class SeriesInfo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            toggleOnIndex: 0,
            dealerList: ['4S店', '综合店', '港口店'],
            dealerTip: ['4S', '综', '港'],
            citycode: this.props.curCity && this.props.curCity.citycode ? this.props.curCity.citycode : '110000',
            cityName: this.props.curCity && this.props.curCity.cityname ? this.props.curCity.cityname : '北京',
            cityShow: false,
        };
        // 这边绑定是必要的，这样 `this` 才能在回调函数中使用
        this.handleClick = this.handleClick.bind(this);
    }
    static propTypes = {
        content: PropTypes.array,
        curCity: PropTypes.object,
        seriesInfo: PropTypes.object,
    };
    state = {
        carExhaustVolume: [],
        biansuxiang: [],
        dealerData: [],
        cityData: [],
        cityLetter: [],
        citypinyin: '',
    };

    async changeDealerData(citycode, serialId) {
        try {
            if (this.props.content[0].serialId) {
                this.setState({
                    dealerData: [],
                });
                const dealerData = await getDealer(citycode, serialId);

                this.setState({
                    dealerData,
                });
            }
        } catch (e) {
            console.error(e);
        }
    }

    async componentDidMount() {
        try {
            if (this.props.content[0].serialId) {
                const dealerData = await getDealer(this.state.citycode, this.props.content[0].serialId);
                const cityData = (await getCityInfo()).cityArr;
                const cityLetter = (await getCityInfo()).cityLetter;

                this.setState({
                    dealerData,
                    cityData,
                    cityLetter,
                    citypinyin: this.props.curCity.citypinyin ? this.props.curCity.citypinyin : 'beijing',
                });
            }
        } catch (e) {
            console.error(e);
        }
    }

    handleClick(index) {
        this.setState(() => ({
            toggleOnIndex: index,
        }));
    }
    cityClick(code, name, pinyin) {
        this.setState(() => ({
            citycode: code,
            cityName: name,
            citypinyin: pinyin,
        }));
        this.changeDealerData(code, this.props.content[0].serialId);
    }
    cityClose() {
        this.setState(() => ({
            cityShow: false,
        }));
    }

    cityShow() {
        this.setState(() => ({
            cityShow: true,
        }));
    }
    scrollToAnchor(id) {
        document.getElementById('city').scrollTop =
            document.getElementById(id).offsetTop +
            document.getElementById(id).offsetHeight +
            25 -
            document.getElementById('city').offsetHeight / 2;
    }

    render() {
        const { content, seriesInfo } = this.props;
        const {
            // carExhaustVolume,
            // biansuxiang,
            dealerData,
            dealerList,
            toggleOnIndex,
            dealerTip,
            cityData,
            cityLetter,
            cityShow,
            cityName,
            citypinyin,
        } = this.state;

        return (
            <div>
                {content && seriesInfo && seriesInfo.serialLogo ? (
                    <div className={styles.arl_dl}>
                        <div className={styles.arl_d_md}>
                            <a
                                className={styles.pic}
                                rel={rel}
                                target="_blank"
                                href={`https://car.auto.ifeng.com/series/${content[0].serialId}/`}
                                title={seriesInfo.standardName}>
                                <img
                                    width="150"
                                    height="100"
                                    src={seriesInfo.serialLogo}
                                    alt={seriesInfo.standardName}
                                />
                            </a>
                            <div className={styles.arl_d_md_info}>
                                <a
                                    className={styles.name}
                                    target="_blank"
                                    rel={rel}
                                    href={`https://car.auto.ifeng.com/series/${content[0].serialId}/`}
                                    title={seriesInfo.standardName}>
                                    {seriesInfo.standardName}
                                </a>
                                <div className={styles.price}>
                                    指导价：<a
                                        title={seriesInfo.standardName}
                                        href={`https://data.auto.ifeng.com/price/s-${content[0].serialId}.html`}
                                        target="_blank"
                                        rel={rel}>
                                        <b className={styles.red}>{seriesInfo.guidePrice}</b>
                                    </a>万元
                                </div>
                                <div className={styles.emissions}>
                                    <label>排量：</label>
                                    {seriesInfo.carExhaustVolume.map((item, index) => <span key={index}>{item}</span>)}
                                </div>
                                <div className={styles.transmission}>
                                    <label>变速箱：</label>
                                    {seriesInfo.biansuxiang.map((item, index) => <span key={index}>{item}</span>)}{' '}
                                </div>
                                <div className={styles.link}>
                                    <a
                                        title={`${seriesInfo.standardName}车系首页 `}
                                        target="_blank"
                                        rel={rel}
                                        href={`https://car.auto.ifeng.com/series/${content[0].serialId}/`}>
                                        <span>车系首页</span>
                                    </a>
                                    <a
                                        title={`${seriesInfo.standardName}参数配置 `}
                                        target="_blank"
                                        rel={rel}
                                        href={`https://car.auto.ifeng.com/series/${content[0].serialId}/spec/`}>
                                        <span>参数配置</span>
                                    </a>
                                    <a
                                        title={`${seriesInfo.standardName}实拍图片 `}
                                        target="_blank"
                                        rel={rel}
                                        href={`https://data.auto.ifeng.com/photo/s-${content[0].serialId}.html`}>
                                        <span>实拍图片</span>
                                    </a>
                                    <a
                                        title={`${seriesInfo.standardName}报价 `}
                                        target="_blank"
                                        rel={rel}
                                        href={`https://data.auto.ifeng.com/price/s-${content[0].serialId}.html`}>
                                        <span>报价</span>
                                    </a>
                                    <a
                                        title={`${seriesInfo.standardName}文章 `}
                                        target="_blank"
                                        rel={rel}
                                        href={`https://car.auto.ifeng.com/series/${content[0].serialId}/news/`}>
                                        <span>文章</span>
                                    </a>
                                </div>
                            </div>
                            <s className={styles.edges_tl} />
                            <s className={styles.edges_br} />
                        </div>
                        <div className={styles.arl_pro}>
                            <div className={styles.arl_pro_tit}>
                                <h3>最热促销</h3>
                                <ul className={styles.siwtch_t}>
                                    {dealerList.map((item, index) => (
                                        <li
                                            key={index}
                                            onClick={() => {
                                                this.handleClick(index);
                                            }}
                                            onMouseEnter={() => {
                                                this.handleClick(index);
                                            }}
                                            className={toggleOnIndex === index ? styles.on : ''}>
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                                <div className={styles.arl_pro_city}>
                                    <div className={styles.on}>
                                        <label>当前城市：</label>
                                        <b id="current-city">{cityName}</b>
                                    </div>
                                    <div className={styles.nav_link}>
                                        <div
                                            className={styles.btn}
                                            onClick={() => {
                                                this.cityShow();
                                            }}
                                            onMouseEnter={() => {
                                                this.cityShow();
                                            }}
                                            onMouseLeave={() => {
                                                this.cityClose();
                                            }}>
                                            切换城市
                                        </div>
                                        <div
                                            className={cityShow ? styles.cx_city_n : styles.cx_city_hide}
                                            onMouseEnter={() => {
                                                this.cityShow();
                                            }}>
                                            <a
                                                className={styles.close}
                                                onClick={() => {
                                                    this.cityClose();
                                                }}>
                                                关闭
                                            </a>
                                            <i className={styles.arrow} />
                                            <div className={styles.cx_city_br}>
                                                <div className={styles.cx_city_le}>
                                                    <ul>
                                                        {cityLetter &&
                                                            cityLetter.map((item, index) => (
                                                                <li key={index}>
                                                                    <a
                                                                        href="javascript:void(0);"
                                                                        onClick={() => this.scrollToAnchor(item)}>
                                                                        {item}
                                                                    </a>
                                                                </li>
                                                            ))}
                                                    </ul>
                                                </div>
                                                <div className={styles.cx_city_nlst} id="city">
                                                    {cityData &&
                                                        cityData.map((item, index) => (
                                                            <dl
                                                                key={index}
                                                                className={index % 2 === 0 ? styles.cbg : ''}>
                                                                <dt id={item[0].toUpperCase()}>
                                                                    {item[0].toUpperCase()}
                                                                </dt>
                                                                {item.slice(1, item.length).map((liitem, liindex) => (
                                                                    <dd key={liindex}>
                                                                        <a
                                                                            href="javascript:void(0);"
                                                                            val={liitem
                                                                                .split(',')[1]
                                                                                .replace(/(^\s*)|(\s*$)/g, '')}
                                                                            data={liitem
                                                                                .split(',')[2]
                                                                                .replace(/(^\s*)|(\s*$)/g, '')}
                                                                            onClick={() => {
                                                                                this.cityClick(
                                                                                    liitem
                                                                                        .split(',')[2]
                                                                                        .replace(/(^\s*)|(\s*$)/g, ''),
                                                                                    liitem
                                                                                        .split(',')[0]
                                                                                        .replace(/(^\s*)|(\s*$)/g, ''),
                                                                                    liitem
                                                                                        .split(',')[1]
                                                                                        .replace(/(^\s*)|(\s*$)/g, ''),
                                                                                );
                                                                            }}>
                                                                            {liitem.split(',')[0]}
                                                                        </a>
                                                                    </dd>
                                                                ))}
                                                            </dl>
                                                        ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <a
                                    href={`//auto.ifeng.com/${citypinyin}/jiangjia/`}
                                    target="_blank"
                                    className={styles.morejiangjia}>
                                    更多降价信息&gt;&gt;
                                </a>
                            </div>
                            <div className={styles.siwtch_content}>
                                {dealerData &&
                                    dealerData.map((item, index) => (
                                        <div
                                            key={index}
                                            className={
                                                toggleOnIndex === index
                                                    ? styles.siwtch_layout_show
                                                    : styles.siwtch_layout_hide
                                            }>
                                            <ul className={styles.sale}>
                                                {item.map((liitem, liindex) => (
                                                    <li key={liindex}>
                                                        <div className={styles.pb_l1}>
                                                            <div className={styles.tit}>
                                                                <a
                                                                    href={
                                                                        liitem.carId
                                                                            ? `http://dealer.auto.ifeng.com/${
                                                                                  liitem.did
                                                                              }/price_car_${liitem.carId}.html`
                                                                            : `http://dealer.auto.ifeng.com/${
                                                                                  liitem.did
                                                                              }/`
                                                                    }
                                                                    target="_blank"
                                                                    rel={rel}
                                                                    className={styles.name}>
                                                                    {liitem.carName}
                                                                </a>
                                                                <b>{dealerTip[index]}</b>
                                                            </div>
                                                            <a
                                                                href={`http://dealer.auto.ifeng.com/${liitem.did}/`}
                                                                className={styles.dl}
                                                                target="_blank"
                                                                rel={rel}>
                                                                {liitem.coaName}
                                                            </a>
                                                            <a
                                                                href={`http://dealer.auto.ifeng.com/${liitem.did}/`}
                                                                className={styles.tel}
                                                                target="_blank"
                                                                rel={rel}>
                                                                {liitem.tel}
                                                            </a>
                                                        </div>
                                                        <div className={styles.pb_l2}>
                                                            <em className={styles.lt}>{liitem.guidePrice}万</em>
                                                            <em className={styles.red}>{liitem.price}万</em>
                                                        </div>
                                                        {liitem.comparePrice > 0 ? (
                                                            <div className={styles.pb_l2}>
                                                                <em className={styles.red}>
                                                                    降{liitem.comparePrice}万
                                                                </em>
                                                                <em>
                                                                    降幅{' '}
                                                                    {(
                                                                        (
                                                                            (parseFloat(liitem.guidePrice) -
                                                                                parseFloat(liitem.price)) /
                                                                            parseFloat(liitem.guidePrice)
                                                                        ).toFixed(2) * 100
                                                                    )
                                                                        .toFixed(0)
                                                                        .toString()}%
                                                                </em>
                                                            </div>
                                                        ) : (
                                                            <div className={styles.pb_l2}>
                                                                <em className={styles.red}>热销中</em>
                                                                <em>&nbsp;&nbsp;&nbsp;-</em>
                                                            </div>
                                                        )}

                                                        <div className={styles.pb_l3}>
                                                            <a
                                                                href={
                                                                    liitem.carId
                                                                        ? `http://dealer.auto.ifeng.com/${
                                                                              liitem.did
                                                                          }/price_car_${liitem.carId}.html#from_top`
                                                                        : `http://dealer.auto.ifeng.com/${liitem.did}/`
                                                                }
                                                                target="_blank"
                                                                className={styles.ask}
                                                                rel={rel}>
                                                                询最低价
                                                            </a>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default errorBoundary(SeriesInfo);
